import {useEffect, useState} from "react";
import {usePopper} from "react-popper";
import InvoiceFilterModal from "../modals/invoice/InvoiceFilterModal";
import { useTranslation } from "../../hooks/useTranslation";

export function InvoiceFilter({awailableColumns, selectedColumns, toggleColumn, setFilter, filter}) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const isFilterState = (state) => {
        return filter.current_state_id.includes(state);
    }

    const toggleFilterState = (state) => {
        if (isFilterState(state)) {
            filter.current_state_id.splice(filter.current_state_id.indexOf(state), 1);
        } else {
            filter.current_state_id.push(state);
        }
        setFilter({...filter});
        console.log(filter)
    }

    return (
        <div
            className="d-lg-flex justify-content-end text-end text-md-start"
            data-kt-customer-table-toolbar="base"
        >
              <span className="d-none d-md-inline">
                <button
                    type="button"
                    className={
                        "btn me-3 mb-2 " +
                        (isFilterState("paid") ? "btn-success" : "btn-secondary")
                    }
                    onClick={() => toggleFilterState("paid")}
                >
                  {t("invoices.paid")}
                </button>

                <button
                    type="button"
                    className={
                        "btn me-3 mb-2 " +
                        (isFilterState("unpaid") ? "btn-warning" : "btn-secondary")
                    }
                    onClick={() => toggleFilterState("unpaid")}
                >
                  {t("invoices.unpaid")}
                </button>

                <button
                    type="button"
                    className={
                        "btn me-3 mb-2 " +
                        (isFilterState('unpaidAfterDueDate') ? "btn-danger" : "btn-secondary")
                    }
                    onClick={() =>
                        toggleFilterState("unpaidAfterDueDate")
                    }
                >
                  {t("invoices.unpaidAfterDueDate")}
                </button>
              </span>

            <button
                type="button"
                className="btn btn-light-primary me-3"
                onClick={()=>setShowModal(true)}
            >
                <i className="ki-duotone ki-filter fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>
                {t("common.filter")}
            </button>

            <InvoiceFilterModal
                filter={filter}
                setFilter={setFilter}
                awailableColumns={awailableColumns}
                toggleColumn={toggleColumn}
                selectedColumns={selectedColumns}
                show={showModal}
                handleClose={()=>setShowModal(false)}
            />

        </div>
    )
}